import React from 'react';

// Components
import WpBadge from '../WpBadge';

const BadgeDocs = () => {
  const sizes = ['sm', 'md', 'lg'] as const;
  const colors = ['blue', 'green', 'orange', 'red', 'yellow', 'gray', 'purple'] as const;

  return (
    <>
      <h5>Variant = default</h5>
      {sizes.map(size => {
        return (
          <div className="d-flex mb-4" key={size}>
            {colors.map(color => {
              return (
                <WpBadge className="mr-1" key={`${size}-${color}`} size={size} color={color}>
                  {color}
                </WpBadge>
              );
            })}
          </div>
        );
      })}
      <hr />
      <h5>Variant = bold</h5>
      {sizes.map(size => {
        return (
          <div className="d-flex mb-4" key={size}>
            {colors.map(color => {
              return (
                <WpBadge className="mr-1" key={`${size}-${color}`} size={size} color={color} variant="bold">
                  {color}
                </WpBadge>
              );
            })}
          </div>
        );
      })}
      <hr />
      <h5>Variant = outline</h5>
      {sizes.map(size => {
        return (
          <div className="d-flex mb-4" key={size}>
            {colors.map(color => {
              return (
                <WpBadge className="mr-1" key={`${size}-${color}`} size={size} color={color} variant="outline">
                  {color}
                </WpBadge>
              );
            })}
          </div>
        );
      })}

      <h1>
        With H1 <WpBadge size="lg">NEW</WpBadge>
      </h1>
      <h2>
        With H2 <WpBadge>NEW</WpBadge>
      </h2>
      <h3>
        With H3 <WpBadge>NEW</WpBadge>
      </h3>
      <h4>
        With H4 <WpBadge>NEW</WpBadge>
      </h4>
      <h5>
        With H5 <WpBadge>NEW</WpBadge>
      </h5>
      <h6>
        With H6 <WpBadge>NEW</WpBadge>
      </h6>
      <p>
        With p <WpBadge>NEW</WpBadge>
      </p>
    </>
  );
};

export default BadgeDocs;
